import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel } from '@material-ui/core';
import { ErrorOption } from 'react-hook-form';

interface EntryFileFieldProp {
  name: string;
  label: string;
  value?: string;
  fileName?: string;
  errors?: any;
  required?: boolean;
  register: (rules: any) => any;
  setError: (name: string, option: ErrorOption) => void;
  clearErrors: (name: string) => void;
  visible?: boolean;
  preview?: boolean;
  acceptContentTypes?: string;
}
export default function EntryFileField({
  name,
  label,
  value, fileName,
  errors = [],
  required = false,
  register,
  setError,
  clearErrors,
  visible = true,
  preview = true,
  acceptContentTypes = 'image/png,image/jpeg',
}: EntryFileFieldProp) {
  const [content, setContent] = useState<string>();
  const [contentName, setContentName] = useState<string>();

  useEffect(() => {
    if(!!value) setContent(value); 
    if(!!fileName) setContentName(fileName);
  }, []);

  const onChange = async (files: FileList | null) => {
    if(!files || files.length === 0) return ;

    const file = files[0];

    if(file.size > 1024 * 1000) {
      setError(name, {
        type: 'maxLength',
      });
      setContent(undefined);
      setContentName(undefined);
      
    } else {
      const rawData = await getBase64(file);

      clearErrors(name);
      setContent(rawData);
      setContentName(file.name);
    }
  }
  const getBase64 = async (file: File): Promise<any> => {
    if(!file) return undefined;

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
      reader.onerror = (error) => {
        reject(error);
      }
    })
  }
  return visible && (
    <>
      <FormControl className="entry-field entry-file" component="fieldset">
        <FormLabel htmlFor={name} component="legend">{label}</FormLabel>
        <div className="grid">
          <div className="grid-item">
            <input
              type="file"
              accept={acceptContentTypes}
              onChange={e => onChange(e.target.files)}
            />
          </div>
          <div className="grid-item">
            {preview && content && (
              <img className="preview" src={content} alt="" />
            )}
            {!preview && content && (
              <p>添付あり</p>
            )}
          </div>
        </div>
        <input
          type="hidden"
          id={name}
          name={name}
          value={content}
          ref={register({required})}
        />
        <input
          type="hidden"
          id={`${name}Name`}
          name={`${name}Name`}
          value={contentName}
          ref={register({required})}
        />
        {required && errors[name] && errors[name].type === 'required' && (
          <span className="entry-field-error">{`${label}を選択してください`}</span>
        )}
        {errors[name] && errors[name].type === 'maxLength' && (
          <span className="entry-field-error">１MB以下のファイルを選択してください</span>
        )}
      </FormControl>
    </>
  );
}